import { render, staticRenderFns } from "./RequisicaoEnvios.vue?vue&type=template&id=1df19324"
import script from "./RequisicaoEnvios.vue?vue&type=script&lang=js"
export * from "./RequisicaoEnvios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports